import React, { Component } from 'react';
import { connect } from 'react-redux';

import i18n from 'app/common/i18n';
import StyleSheet from 'stilr';

import {
  threads as getThreads,
  messages as getMessages
} from 'app/redux/modules/messages';
import Loading from 'app/common/Loading';

import ListItem from './list-item';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { setTitle } from 'app/layout/redux';

import TextInputWithButton from '../boligsoegerlisten/adminInput';

function getUser(user) {
  return {
    id: user.id || user.get?.('id') || '',
    firstname: user.firstname || user.get?.('firstname') || '',
    lastname: user.lastname || user.get?.('lastname') || '',
    email: user.email || user.get?.('email') || '',
    phone: user.phone || user.get?.('phone') || '',
    uuid: user.uuid || user.get?.('uuid') || '',
    company: user.company || user.get?.('company') || '',
    companyAddress: user.companyAddress || user.get?.('companyAddress') || '',
    cvr: user.cvr || user.get?.('cvr') || '',
    type: user.type || user.get?.('type') || '',
    expireAt: user.expireAt || user.get?.('expireAt') || ''
  };
}

function isAdmin(user) {
  try {
    return (user && user.get('role') === 'admin') || false;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
  }
  return false;
}

const styles = StyleSheet.create({
  label: {
    display: 'inline-block',
    marginRight: '6px',
    fontSize: '10px',
    background: 'rgb(224, 224, 224)',
    borderRadius: '8px',
    padding: '0 10px',
    lineHeight: '20px',
    verticalAlign: 'top',
    textTransform: 'capitalize'
  },
  blur: {
    color: 'transparent !important',
    textShadow: '0 0 5px rgba(0,0,0,0.4)'
  }
});

function sortBy(key, asc) {
  const returnValues = asc ? [1, -1] : [-1, 1];
  let newKey = key;
  switch (key) {
    case 'status':
      newKey = 'status';
      break;
    case 'address':
      newKey = 'dwelling.address';
      break;
    case 'seeker':
      newKey = 'seeker';
      break;
    case 'latest':
      newKey = 'latestMessage';
      break;
    case 'updatedAt':
      newKey = 'updatedAt';
      break;
    case 'createdAt':
      newKey = 'updatedAt';
      break;
    default:
      newKey = 'createdAt';
      break;
  }

  return (a, b) => {
    if (/\./.test(newKey)) {
      const keys = newKey.split('.');
      return a[keys[0]][keys[1]] || 0 > b[keys[0]][keys[1]] || 0
        ? returnValues[0]
        : a[keys[0]][keys[1]] || 0 < b[keys[0]][keys[1]]
        ? returnValues[1]
        : 0;
    }
    return a[newKey] || 0 > b[newKey] || 0
      ? returnValues[0]
      : a[newKey] || 0 < b[newKey]
      ? returnValues[1]
      : 0;
  };
}

@connect(
  ({ messages, dwellings, auth: { user } }) => ({
    dwellings,
    user,
    messages
  }),
  {
    setTitle,
    getMessages,
    getThreads
  }
)
@i18n
class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { user: _user } = this.props;
    const user = getUser(_user);
    const admin = isAdmin(_user);
    const landlordId = user.id;

    this.props.setTitle(this.props.i18n('Messages'));
    if (admin) {
      this.props.getMessages('threads', 'admin').then((res) =>
        this.setState({
          data:
            res?.payload?.result?.sort(
              sortBy('updatedAt', this.state?.isAsc)
            ) || []
        })
      );
    } else {
      this.props.getMessages('threads', landlordId).then((res) =>
        this.setState({
          data:
            res?.payload?.result?.sort(
              sortBy('updatedAt', this.state?.isAsc)
            ) || []
        })
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.messages !== nextProps.messages) {
      this.setState({
        data: nextProps.messages.data,
        isAsc: false
      });
    }
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  render() {
    const { disabled, style = {}, user } = this.props;
    const cellClassName = [disabled && styles.blur].filter(Boolean).join(' ');
    const admin = isAdmin(user);

    const handleSort = (value) => {
      const data = this.state?.data;
      if (!data || !value) {
        return;
      }

      const key = value;
      this.setState({
        data: data.sort(sortBy(key, this.state?.isAsc)),
        isAsc: !this.state?.isAsc
      });
    };

    const makeTableCell = (value, title) => {
      return (
        <TableCell
          key={value}
          onClick={() => handleSort(value)}
          value={value}
          style={{ textAlign: 'center' }}
        >
          {this.props.i18n(title)}
        </TableCell>
      );
    };

    const onClick = (text, option) => {
      const id = text;

      this.setState({ loading: true });
      this.props
        .getThreads({ option, id })
        .then((res) =>
          this.setState({ data: res?.payload?.result || [], loading: false })
        )
        .catch(() => this.setState({ loading: false }));
    };

    return (
      <div style={{ overflowX: 'auto' }}>
        {admin ? (
          <TextInputWithButton
            onClick={onClick}
            options={['User', 'Dwelling']}
            placeholder="Enter ID"
            label={this.props.i18n('Lookup')}
          />
        ) : null}
        <Table style={{ ...style, tableLayout: 'auto', minWidth: 700 }}>
          <TableHead>
            <TableRow>
              {[
                ['status', this.props.i18n('Status')],
                ['address', this.props.i18n('Address')],
                ['seeker', this.props.i18n('Seeker')],
                ['latest', this.props.i18n('Latest message')],
                ['createdAt', this.props.i18n('Created')],
                ['updatedAt', this.props.i18n('Updated')]
              ].map((header) => makeTableCell(header[0], header[1]))}
            </TableRow>
          </TableHead>
          {this.state.data?.length ? (
            <TableBody style={{ tableLayout: 'auto' }}>
              {this.state.data.map((item, idx) => (
                <ListItem
                  key={item._id || idx}
                  item={item}
                  cellClassName={cellClassName}
                  admin={admin}
                  user={user}
                  onClose={onClick}
                />
              ))}
            </TableBody>
          ) : null}
        </Table>
        {this.state?.loading ? (
          <Loading />
        ) : !this.state?.data?.length ? (
          <div style={{ padding: '22px', textAlign: 'center' }}>
            <i>{this.props.i18n('No messages')}</i>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Messages;